var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report-slider" }, [
    _vm.slides && _vm.slides.length > 0
      ? _c("div", [
          _c("div", { staticClass: "requirements-nav" }, [
            _c("nav", [
              _c(
                "ul",
                _vm._l(_vm.slideNav, function (navItem) {
                  return _c(
                    "li",
                    { key: navItem.id, staticClass: "country__icon" },
                    [
                      _c("img", {
                        key: navItem.id,
                        staticClass: "requirements-nav-checkbox",
                        attrs: {
                          src: `${_vm.formatFlagString(navItem.iso)}`,
                          alt: navItem.name,
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showSlides && _vm.slides && _vm.slides.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "swiper",
                    {
                      ref: "reportSlider",
                      attrs: { options: _vm.optionsPaginationTop },
                    },
                    _vm._l(_vm.slides, function (article, index) {
                      return _c("swiper-slide", { key: index }, [
                        _c("div", { staticClass: "requirements-row" }, [
                          _c("div", { staticClass: "country-title--wrapper" }, [
                            _c("img", {
                              key: article.id,
                              staticClass: "requirements-row-flag",
                              attrs: {
                                src: `${_vm.formatFlagString(article.iso)}`,
                                alt: article.name,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "country-title" }, [
                              _c("strong", [_vm._v(_vm._s(article.name))]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(
                              article.paragraphs,
                              function (paragraph, idx) {
                                return _c("div", {
                                  key: idx,
                                  domProps: { innerHTML: _vm._s(paragraph) },
                                })
                              }
                            ),
                            0
                          ),
                        ]),
                      ])
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("DirectionButton", {
                    staticClass:
                      "report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev",
                    attrs: {
                      "props-handle-click": _vm.prev,
                      direction: "prev",
                      icon: "arrow-left--white",
                    },
                  }),
                  _vm._v(" "),
                  _c("DirectionButton", {
                    staticClass:
                      "report-slider__pagination--next report-slider__pagination-top--next swiper-button-next",
                    attrs: {
                      "props-handle-click": _vm.next,
                      direction: "next",
                      icon: "arrow-right--white",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }